import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './marquee.css';

const Marquee = props => {
  return (
    <div className={cx('marquee', {})}>
      <div className="marquee-content">{props.text}</div>
    </div>
  );
};

Marquee.defaultProps = {
  text: '',
};

Marquee.propTypes = {
  text: PropTypes.string,
};

export default Marquee;



// WEBPACK FOOTER //
// ./src/app/component/marquee/marquee.js